"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _walletValidatorJs = require("wallet-validator-js");
var _coinslot = require("coinslot");
var _config = _interopRequireDefault(require("../../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _config$CryptoAddress = _config["default"].CryptoAddressValidation,
  DoNotValidate = _config$CryptoAddress.DoNotValidate,
  ValidateAsERC20 = _config$CryptoAddress.ValidateAsERC20,
  UseDeprecatedValidate = _config$CryptoAddress.UseDeprecatedValidate;
var shouldNotValidate = function shouldNotValidate(productSymbol) {
  return DoNotValidate.includes(productSymbol);
};
var shouldValidateAsERC20 = function shouldValidateAsERC20(productSymbol) {
  return ValidateAsERC20.includes(productSymbol);
};
var shouldUseDeprecatedValidate = function shouldUseDeprecatedValidate(productSymbol) {
  return UseDeprecatedValidate.includes(productSymbol);
};
var _default = exports["default"] = function _default(productSymbol) {
  var errorMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ' ';
  return function (address) {
    if (!productSymbol) return undefined;
    if (address === undefined) return undefined;
    if (shouldNotValidate(productSymbol)) return undefined;
    var format = function format(isValid) {
      return isValid ? undefined : errorMessage;
    };
    try {
      if (shouldUseDeprecatedValidate(productSymbol.toUpperCase())) {
        return format((0, _coinslot.validate)(address, productSymbol.toUpperCase()));
      }
      if (shouldValidateAsERC20(productSymbol)) {
        return format((0, _walletValidatorJs.validate)(address, 'ETH', 'both'));
      }
      return format((0, _walletValidatorJs.validate)(address, productSymbol, 'both'));
    } catch (e) {
      /**
       * Currency not supported.
       */
      return undefined;
    }
  };
};